export default __webpack_public_path__ + "static/media/tooltip_icon_white.007218dd.svg";